import { httpGet, httpPost } from "../../providers"
import { AssociationId, ProfilePk, ProfileSyncSessionId, Username } from "../../types"

// Purposefully fire and forget, as the backend logic is potentially very long running.
const prepareProfileDownload = (
  association: AssociationId,
  currentSessionId: ProfileSyncSessionId,
  username: Username,
  profileHashes: Record<ProfilePk, string>,
  token: string,
) => {
  try {
    const body = { profileHashes }
    httpPost(
      "people_flow_core",
      `/profiles/prepare-download/${association}/${currentSessionId}/${username}`,
      body,
      token,
    )
  } catch (error) {
    throw error
  }
}

const getNextBatchFileParams = async (
  association: AssociationId,
  currentSessionId: ProfileSyncSessionId,
  username: Username,
  token: string,
) => {
  try {
    const { data } = await httpGet(
      "people_flow_core",
      `/profiles/download-batch-params/${association}/${currentSessionId}/${username}`,
      token,
    )
    const { isBatch, isLoading, fileConfig } = data
    return { isBatch, isLoading, fileConfig }
  } catch (error) {
    throw error
  }
}

const markBatchCompletion = async (
  association: AssociationId,
  currentSessionId: ProfileSyncSessionId,
  username: Username,
  fileNameAndFormat: string,
  token: string,
) => {
  try {
    const body = { fileNameAndFormat }
    const { data } = await httpPost(
      "people_flow_core",
      `/profiles/mark-batch-completion/${association}/${currentSessionId}/${username}`,
      body,
      token,
    )
    return data
  } catch (error) {
    throw error
  }
}

export { prepareProfileDownload, getNextBatchFileParams, markBatchCompletion }
